document.addEventListener('DOMContentLoaded', function () {
  const search = document.getElementById('drSearch');
  if (!search) return;

  const openButtons = document.querySelectorAll('[data-search-open]');
  const closeButtons = search.querySelectorAll('[data-search-close]');
  const input = search.querySelector('.dr-search__input');

  function openSearch() {
    search.classList.add('is-open');
    search.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dr-search-lock');
    document.body.classList.add('dr-search-lock');

    setTimeout(() => {
      if (input) input.focus();
    }, 50);
  }

  function closeSearch() {
    search.classList.remove('is-open');
    search.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dr-search-lock');
    document.body.classList.remove('dr-search-lock');
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openSearch();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', function () {
      closeSearch();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && search.classList.contains('is-open')) {
      closeSearch();
    }
  });
});